import { ModalBody, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T, TPlainTextKey } from '../../../Translations';

interface ModalContentProps {
  children: React.ReactNode;
  title: TPlainTextKey;
  desc: TPlainTextKey;
}

function ModalContent({ title, children, desc }: ModalContentProps) {
  return (
    <ModalBody className="max-w-96">
      <Typography variant="h5" fontWeight="semibold" color="black" className="py-4 text-center">
        <T kind={title} />
      </Typography>
      <Typography variant="bodyMedium" className="pb-14 text-center">
        <T kind={desc} />
      </Typography>
      {children}
    </ModalBody>
  );
}

export default observer(ModalContent);
